<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <!--    table    -->
        <div class="section-title">
            <div>商品明细</div>
        </div>
        <div class="edit-ctn" id="editCtn">
            <!--      table title      -->
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 18%; flex-grow: 1">汽配编码</div>
                <div class="div-table-cell" style="width: 18%">配件名称</div>
                <div class="div-table-cell" style="width: 7%">数量</div>
                <div class="div-table-cell" style="width: 7%">单位</div>
                <div class="div-table-cell" style="width: 10%"><span class="color-red">*</span>成本价</div>
                <div class="div-table-cell" style="width: 10%">成本总价</div>
            </div>
            <div class="table-main">
                <div v-bind:key="index" class="div-table-row table-item" v-for="(item, index) in orderDetailList" :ref="'pj' + index">
                    <!-- slot-scope="scope" -->
                    <!--        编码            -->
                    <div class="div-table-cell div-table-cell-code" style="width: 18%; flex-grow: 1">
                        <el-link :underline="false" type="primary" @click="showAPMsgDialog(item.GoodsId)">{{ item.APCode }}</el-link>
                        <div v-if="item.State == 1" class="row-delete">已删除</div>
                    </div>
                    <!--        名称            -->
                    <div class="div-table-cell" style="width: 18%">
                        {{ item.GoodName }}
                    </div>
                    <!--        数量            -->
                    <div class="div-table-cell" style="width: 7%">
                        {{ item.Count }}
                    </div>
                    <!--        单位         -->
                    <div class="div-table-cell" style="width: 7%">
                        {{ item.Unit }}
                    </div>
                    <!--        成本价            -->
                    <div class="div-table-cell" style="width: 10%">
                        <el-input-number size="small" style="width:100%" v-model="item.CostPrice" :precision="2" :step="0.1" :min="0" @change="val => costPriceInputEvent(val, item)"></el-input-number>
                    </div>
                    <!--        成本总价            -->
                    <div class="div-table-cell" style="width: 10%; font-weight: 700">
                        {{ item.totalCost }}
                    </div>
                </div>
                <div class="div-table-row table-item">
                    <div class="div-table-cell" style="width: 18%; flex-grow: 1"></div>
                    <div class="div-table-cell" style="width: 18%; font-weight: 700">总数量</div>
                    <div class="div-table-cell" style="width: 7%; font-weight: 700">
                        <el-tooltip effect="dark" :content="totalCount.toString()" placement="top">
                            <span>{{ totalCount }}</span>
                        </el-tooltip>
                    </div>
                    <div class="div-table-cell" style="width: 7%"></div>
                    <div class="div-table-cell" style="width: 10%; font-weight: 700">合计</div>
                    <div class="div-table-cell" style="width: 10%; font-weight: 700">
                        <el-tooltip effect="dark" :content="summation.toString()" placement="top">
                            <span>{{ summation }}</span>
                        </el-tooltip>
                    </div>
                </div>
                <el-button style="float: right; margin: 10px" size="middle" class="search-btn btn-primary" @click="submit()">提交</el-button>
            </div>
            <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
                <div v-if="APMsgVisible">
                    <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        breadcrumb
    },
    data() {
        return {
            APCode: '',
            EntpTempGoodsIdEdit: '',
            orderDetailList: [],
            id: '',
            permission: {},
            totalCount: 0,
            summation: 0,
            APMsgVisible: false
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('transToPurchaseOrder');
        this.id = this.$route.query.id;
        this.getOrderDetail();
    },
    watch: {
        //计算总数量
        orderDetailList: function (obj) {
            for (let i = 0; i < obj.length; i++) {
                this.totalCount = obj[i].Count + this.totalCount;
            }
        },
        deep: true
    },
    methods: {
        goBack() {
            window.history.go(-1);
        },
        //计算成本总价
        costPriceInputEvent(val, item) {
            item.costPrice = val;
            item.totalCost = item.CostPrice * item.Count;
            let summation = 0;
            this.orderDetailList.forEach(element => {
                summation += element.totalCost;
            });
            this.summation = summation.toFixed(2);
        },
        //获取订单详情
        getOrderDetail() {
            let that = this;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetSaleOrderGoodsList',
                    data: {
                        OrderId: this.id
                    }
                })
                .then(res => {
                    that.orderDetailList = res.data;
                    let summation = 0;
                    for (let i = 0; i < that.orderDetailList.length; i++) {
                        let num = that.orderDetailList[i].CostPrice * that.orderDetailList[i].Count;
                        that.orderDetailList[i].totalCost = num.toFixed(2) * 1;
                        summation += that.orderDetailList[i].totalCost;
                    }
                    that.summation = summation.toFixed(2);
                });
        },
        //提交
        submit() {
            let that = this;
            for (let i = 0; i < this.orderDetailList.length; i++) {
                this.orderDetailList[i].orderGoodsRsId = this.orderDetailList[i].OrderGoodsRsId;
                this.orderDetailList[i].costPrice = this.orderDetailList[i].CostPrice;
                if (this.orderDetailList[i].State != 0) {
                    this.$util.warningMsg('商品【' + this.orderDetailList[i].GoodName + '（' + this.orderDetailList[i].APCode + '）' + '】已删除');
                    return;
                }
            }
            this.$util.elConfirm({
                content: '确定要提交吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpSaleOrder/VerifySaleOrderGoodsCost',
                            data: {
                                orderId: that.id,
                                orderGoods: that.orderDetailList
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.getOrderDetail();
                        });
                }
            });
        },
        // 配件信息
        showAPMsgDialog(code) {
            this.EntpTempGoodsIdEdit = code;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0;
    }
}
.table-main {
    position: relative;
}
.table-title {
    line-height: 34px;
    text-align: center;
    font-weight: bold;
    background: #b1c7fa;
}
.div-table-row {
    height: 34px !important;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
    height: 34px;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
}
</style>
<style lang="less">
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
</style>
